exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Ays9IjKWX7OInIwlZEp5X{color:\"[theme:neutralPrimary, default:#333333]\";min-height:48px}html[dir] ._3Ays9IjKWX7OInIwlZEp5X{-webkit-box-shadow:0 17px 0 -16px \"[theme:neutralLight, default:#eaeaea]\";box-shadow:0 17px 0 -16px \"[theme:neutralLight, default:#eaeaea]\"}html[dir] ._3Ays9IjKWX7OInIwlZEp5X._16_hIUvqf9J6Kl4UIxdoca{-webkit-box-shadow:0 -17px 0 -16px \"[theme:themePrimary, default:#0078D4]\";box-shadow:0 -17px 0 -16px \"[theme:themePrimary, default:#0078D4]\"}", ""]);

// exports
exports.locals = {
	"placeholderItem": "_3Ays9IjKWX7OInIwlZEp5X",
	"topBorderDragOver": "_16_hIUvqf9J6Kl4UIxdoca"
};